let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ajic1")).then(() => parcelRequire('fEtUg'));